import { COMMON_ADMIN_SECTIONS } from "../constants"
import type { CategorySection } from "../types"

export const adminFormSections: Record<string, CategorySection[]> = {
  "Admin Form": COMMON_ADMIN_SECTIONS,
}
